import React, { Component } from "react";
import TApage1 from "../assets/TA/TA_page1.JPG";
import TApage2 from "../assets/TA/TA_page2.JPG";
import TApage3 from "../assets/TA/TA_page3.JPG";
import TApage4 from "../assets/TA/TA_page4.JPG";
import TApage5 from "../assets/TA/TA_page5.JPG";
import TApage6 from "../assets/TA/TA_page6.JPG";
import TApage7 from "../assets/TA/TA_page7.JPG";
import TApage8 from "../assets/TA/TA_page8.JPG";
import TApage9 from "../assets/TA/TA_page9.JPG";
import TApage10 from "../assets/TA/TA_page10.JPG";

export default class TAForm extends Component {
  instructions = (index) => {
    let elem;
    switch (index) {
      case 0:
        elem = (
          <ul>
            <li>Fill the date and choose the TA option as shown in image</li>
          </ul>
        );
        break;
      case 1:
        elem = (
          <ul>
            <li>If you are a new student, chances are you didn't take TA orientation or the other courses</li>
            <li>
              If you satisfy the English proficiency requirements, then select I satisfy only the English proficiency requirement and the
              3rd option
            </li>
            <li>
              If you are at placement level 3, then you should also select : <b className="text-danger">I still need LLED 7769</b> option
            </li>
          </ul>
        );
        break;

      case 2:
        elem = (
          <ul>
            <li>Upload required certificate in Q5 (TOEFL/IELTS/DUOLINGO)</li>
            <li>Q6 is not required for students with placement level 4. For placement level 3, upload the required document</li>
          </ul>
        );
        break;

      case 3:
        elem = (
          <ul>
            <li>
              If you are level 4 choose NA (if you haven't taken the CLT test and are still lvl 4 due to the Language Profieciency score)
            </li>
            <li>Others choose the respective option</li>
          </ul>
        );
        break;

      case 4:
        elem = (
          <ul>
            <li>Skip Q11 as you might be a new student.</li>
            <li>In Q12, select the option shown in image ("upcoming semester")</li>
          </ul>
        );
        break;

      case 5:
        elem = (
          <ul>
            <li>Mark Q13 as shown in the image</li>
            <li>In Q14, If you are placement level 4, select: I do not need LLED option</li>
            <li>If you are placement level 2 or 3, select: I have not taken LLED 7769</li>
            <li>If you are placement level 1, select: I have not taken LLED 7769 and 7768</li>
          </ul>
        );
        break;

      case 6:
        elem = (
          <ul>
            <li>If you are from India, the Answer will be No</li>
            <li>
              If you were required to give TOEFL/IELTS/Duolingo, the answer will be no because even though your institution might be
              accredited, you country is not identified as English speaking country by UGA (which I guess you already knew)
            </li>
          </ul>
        );
        break;

      case 7:
        elem = (
          <ul>
            <li>
              The form I provided is specific to Computer Science, you can check with University to get the link for other courses. The rest
              of the steps will remain same
            </li>
          </ul>
        );
        break;

      case 8:
        elem = (
          <ul>
            <li>International Students - Foreign National</li>
            <li>Choose your race | country: India - race: Asian</li>
          </ul>
        );
        break;

      case 9:
        elem = (
          <ul>
            <li>Q23 - None</li>
            <li>
              For Q24, List the subjects you have experience in, check the course bulletin to see list of courses (If you are unsure of
              this, mail the university)
            </li>
            <li>Q25 - 0 for new students</li>
          </ul>
        );
        break;

      default:
        break;
    }
    return <React.Fragment>{elem}</React.Fragment>;
  };

  constructor(props) {
    super(props);
    this.state = {
      data: [
        { img: TApage1 },
        { img: TApage2 },
        { img: TApage3 },
        { img: TApage4 },
        { img: TApage5 },
        { img: TApage6 },
        { img: TApage7 },
        { img: TApage8 },
        { img: TApage9 },
        { img: TApage10 },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        {this.state.data.map((item, index) => {
          return (
            <React.Fragment key={"TAPage" + index}>
              <hr />
              <h4>Page {index + 1}</h4>
              <div className="text-center">
                <img src={item.img} className="rounded img-thumbnail packet_page_img" alt="TA ship form" />
              </div>
              <br />
              {this.instructions(index)}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  }
}
